import React, { Component } from 'react'
import classNames from 'classnames';

export default class Ressource extends Component {

  state = {
    showPressed: false,
    showActivated: false,
  }

  touchStartTime = null
  clickTimerId = null

  handleClick() {
    this.props.onClicked()
  }
  handleTouchStart() {
    this.touchStartTime = Date.now()
    this.setState({showPressed: true})
  }
  handleTouchEnd(e) {
    const holdDuration = Date.now() - this.touchStartTime
    const mediumPressThreshold = 500
    console.log("Hold duration", holdDuration)
    this.setState({showPressed: false, showActivated: true})

    e.preventDefault()
    this.touchStartTime = null

    // Delayed click to show interaction feedback before changing screen


    if (this.clickTimerId) {
      clearTimeout(this.clickTimerId)
    }
    this.clickTimerId = setTimeout(() => {

      this.setState({showPressed: false, showActivated: false})
      this.props.onClicked()

    }, 100)
  }
  handleTouchCancel() {
    this.setState({showPressed: false, showActivated: false})
    this.touchStartTime = null
    if (this.clickTimerId) {
      clearTimeout(this.clickTimerId)
    }
    this.clickTimerId = null
  }

  componentWillUnmount() {
    if (this.clickTimerId) {
      clearTimeout(this.clickTimerId)
    }
    this.clickTimerId = null
  }

  handleClick = this.handleClick.bind(this)
  handleTouchStart = this.handleTouchStart.bind(this)
  handleTouchEnd = this.handleTouchEnd.bind(this)
  handleTouchCancel = this.handleTouchCancel.bind(this)

  render() {
    const classes = classNames(
      "categoryButton",
      {
        showPressed: this.state.showPressed,
        showActivated: this.state.showActivated
      }
    )

    let imageIsCovering = this.props.bgImageIsCovering

    return (

      <button className={classes}
        onClick={this.handleClick} onTouchStart={this.handleTouchStart} onTouchEnd={this.handleTouchEnd} onTouchCancel={this.handleTouchCancel}>

        {
          !this.props.bgImageIsCovering &&
            <div className="bgImage"/>
        }
        
        {
          this.props.bgImage &&
          <div className="bgImage" style={{
            backgroundImage: "url(" + this.props.bgImage  + ')',
            backgroundSize: (imageIsCovering ? 'cover' : 'unset'),
            backgroundRepeat: 'no-repeat', 
            backgroundPosition: 'center'}
          }  />
        }
        
        <div className="buttonContent">
          <p className="title">{this.props.name}</p>
          <p className="detail">{this.props.detail}</p>
        </div>
        
      </button>
    )
  }
}
